/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  RequestCodeFlowRequest,
  RequestRegisterCalendarRequest,
  ResponsePsychologistCalendarsResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class GoogleCalendar<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags GoogleCalendar
   * @name GetCalendars
   * @summary  (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/google-calendar/get-calendars
   * @secure
   * @response `200` `(ResponsePsychologistCalendarsResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getCalendars = (params: RequestParams = {}) =>
    this.http.request<ResponsePsychologistCalendarsResponse[], void>({
      path: `/api/v1/google-calendar/get-calendars`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags GoogleCalendar
   * @name GrantAccess
   * @summary  (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/google-calendar/grant-access
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  grantAccess = (data: RequestCodeFlowRequest, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/google-calendar/grant-access`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags GoogleCalendar
   * @name RegisterCalendar
   * @summary  (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/google-calendar/register-calendar
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  registerCalendar = (data: RequestRegisterCalendarRequest, params: RequestParams = {}) =>
    this.http.request<void, void>({
      path: `/api/v1/google-calendar/register-calendar`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
